import styled from 'styled-components';
import theme from '../../../../theme';

export const SelectWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    font-size: 0.8rem;

    label {
        font-weight: 500;
        font-size: 0.75rem;
        margin-bottom: 2px;
    }
    .dropdown-heading {
        height: 28px;
        .dropdown-heading-dropdown-arrow svg {
            height: 20px;
        }
        .dropdown-heading-value {
            color: hsl(0, 0%, 20%);
            font-size: 0.8rem;
            * {
                color: hsl(0, 0%, 20%);
            }
        }
    }

    .tankplan_filter__placeholder {
        color: inherit;
    }
    .tankplan_filter__indicators {
        height: 30px;
    }

    .dropdown-content {
        .panel-content {
            background: ${theme.colors.background.white};
        }
        display: block;

        label.select-item {
            margin: 0 2px 0 0;
            font-weight: 500;
            font-size: 0.8rem;
            font-weight: 400;
            border-bottom: 1px solid ${theme.colors.border.light};
            background: ${theme.colors.background.white};
            color: ${theme.colors.text.black};
        }

        .item-renderer > span {
            display: inline;
            padding-left: 3px;
        }
    }
`;
